<template>
  <div class="navigationBar">
    <div class="nav-list">
      <div class="left">
        <template v-for="(item, index) in navBar">
          <div
            v-if="item.isRutern"
            :key="index"
            @click="toPage(item)"
            class="nav-list__navItem">
            <span :class="`icon iconfont icon-left-1`"></span>
            <span class="text">{{ item.name }}</span>
          </div>
        </template>
      </div>
      <div class="right">
        <template v-for="(item, index) in navBar">
          <div
            v-if="!item.isRutern"
            :key="index"
            @click="toPage(item)"
            class="nav-list__navItem">
            <span :class="`icon iconfont ${item.icon}`"></span>
            <span class="text">{{ item.name }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navBar: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    toPage(item) {
      if (item.isRutern) {
        this.$router.back();
      } else {
        if (item.path) {
          this.$router.replace({
            path: item.path,
            params: item.params,
            query: item.query,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  .page-view {
    .navigationBar {
      width: 100%;
      box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
      padding: 6px 20px;
      background: #ffffff;
      .nav-list {
        display: flex;
        justify-content: space-between;
        &__navItem {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          margin-right: 2px;
          &:nth-last-of-type(1) {
            margin-right: 0;
          }
          .icon {
            font-size: 14px;
            margin-right: 4px;
          }
        }
      }
      .left,
      .right {
        display: flex;
        align-items: center;
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  .page-view {
    .navigationBar {
      width: 100%;
      box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
      padding: 10px 25px;
      background: #ffffff;
      .nav-list {
        display: flex;
        justify-content: space-between;
        &__navItem {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          margin-right: 2px;
          &:nth-last-of-type(1) {
            margin-right: 0;
          }
          .icon {
            font-size: 16px;
            margin-right: 4px;
          }
        }
      }
      .left,
      .right {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
